"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _ZoomOutMap = _interopRequireDefault(require("@material-ui/icons/ZoomOutMap"));
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
var _styles = require("@material-ui/core/styles");
var _CustomControl = _interopRequireDefault(require("./CustomControl.jss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useStyles = (0, _styles.makeStyles)(_CustomControl.default);
const CustomControl = ({
  map
}) => {
  const classes = useStyles();
  // map.setZoom(map.getZoom() + 1);
  // map.setZoom(map.getZoom() - 1);
  // currMap.getDiv().firstChild.requestFullscreen();
  return /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: classes.wrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.btn,
    onClick: e => {
      e.preventDefault();
      map.getDiv().firstChild.requestFullscreen();
    }
  }, /*#__PURE__*/_react.default.createElement(_ZoomOutMap.default, null)), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 2,
    className: classes.btnsGroup
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: [classes.btn, classes.noRadius].join(' '),
    onClick: e => {
      e.preventDefault();
      map.setZoom(map.getZoom() + 1);
    }
  }, /*#__PURE__*/_react.default.createElement(_Add.default, {
    style: {
      fontSize: '0.75rem'
    }
  })), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    variant: "fullWidth",
    style: {
      backgroundColor: '#46556B'
    }
  }), /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: [classes.btn, classes.noRadius].join(' '),
    onClick: e => {
      e.preventDefault();
      map.setZoom(map.getZoom() - 1);
    }
  }, /*#__PURE__*/_react.default.createElement(_Remove.default, {
    style: {
      fontSize: '0.75rem'
    }
  }))));
};
CustomControl.propTypes = {
  map: _propTypes.default.object.isRequired
};
var _default = CustomControl;
exports.default = _default;